import * as Yup from 'yup';

import i18n from '@/i18n';

export const updatePasswordSchema = Yup.object().shape({
  currentPassword: Yup.string().required(i18n.t('passwordRequired', { ns: 'common' })),
  newPassword: Yup.string()
    .min(8, i18n.t('minimumPassword', { ns: 'common' }))
    .required(i18n.t('passwordRequired', { ns: 'common' })),
  confirmNewPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], i18n.t('passwordMatch', { ns: 'common' }))
    .required(i18n.t('passwordRequired', { ns: 'common' }))
});
